<template>
	<div>
		<div class="page-navbar navbar-white" :style="{ zIndex: zIndex }">
			<div class="nav-center-wrapper">
				<img class="navbar-logo" :src="$logoSrc" alt="getREEF Logo" />
			</div>
			<div class="navbar-content desktop-center">
				<button
					class="button button-transparent user-menu-button"
					@click="openUserMenuModal"
				>
					<i class="sk-icon-bars-regular"></i>
				</button>
				<UserPicture @click.native="openUserMenuModal" :size="25" />
			</div>
		</div>
		<div class="navbar-spacer"></div>
		<UserMenuModal
			ref="userMenuModal"
			@show="modalShown"
			@hidden="modalHidden"
		/>
	</div>
</template>

<style scoped>
.button-primary {
	font-size: 12px;
	padding: 7px 25px;
	font-weight: 400;
}
</style>

<script>
import navbarMixin from "@/mixins/navbar-mixin"
import UserMenuModal from "@/components/modals/UserMenuModal.vue"
import UserPicture from "@/components/common/UserPicture.vue"

export default {
	name: "ResidentialCheckoutNavbar",
	mixins: [navbarMixin],
	components: {
		UserMenuModal,
		UserPicture
	},
	data: function () {
		return {
			zIndex: 0
		}
	},
	methods: {
		modalShown() {
			this.zIndex = 5000
		},
		modalHidden() {
			this.zIndex = 0
		}
	}
}
</script>